<template>
    <div
        v-if="popper_isVisible"
        class="float-menu border border-secondary pc-bg-nav-lvl1 text-white d-flex flex-column"
        style="max-height: 100vh">
        <div class="text-center border-bottom border-secondary text-larger p-2">
            {{ navMenu.Text }}
        </div>
        <div
            class="flex-grow-1 py-2"
            style="overflow-y: auto">
            <a
                v-for="item in navMenu.NavMenuItems"
                v-bind:key="item.Text"
                v-bind:ref="item.PageTypeName"
                v-bind:href="getItemUrl(item.Url)"
                class="ps-3 py-2 text-white d-flex floatMenuItem">
                <navIcon
                    v-bind:page-name="item.PageTypeName"
                    class="d-inline me-3" />
                {{ item.Text }}
            </a>
        </div>
    </div>
</template>

<script>
    import popperMixin from "./popperMixin";
    import navIcon from "./navIcon.vue";

    export default {
        components: { navIcon },
        mixins: [popperMixin],
        props: {
            navMenu: { type: Object, required: true }
        },
        methods: {
            getItemUrl(url) {
                return `${url}?ProgramId=${this.$app.ProgramId}`;
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "./_nav-style-vars.scss";

    .float-menu {
        width: 250px;
        z-index: 1000;
    }

    .floatMenuItem {
        text-decoration: none;

        &:hover {
            background-color: $pc-nav-lvl2-color;
        }
    }
</style>
